module.exports = __webpack_public_path__ + "a288db272ba5413a568e625522e03794.png";